import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components';
import { LangSelectModule, ProfilePreviewModule } from '../shared/components';

@NgModule({
  declarations: [LayoutComponent, HeaderComponent],
  imports: [CommonModule, RouterModule, LangSelectModule, ProfilePreviewModule],
})
export class LayoutModule {}
